export default "__VITE_ASSET__BQ57ut9C__"